import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetTypeOfBottleFromUrl } from 'src/hooks'
import { changeFormatOfDate } from 'src/utils/changeFormatOfDate'

import styles from './ConfirmationInfo.module.scss'

interface ConfirmationInfoProps {
  bottleType?: string
  bottleName: string
  bottleAmount: string | number
  bottleDate: { from: string; to: string }
  targetOfBottle?: string
  className?: string
}

const ConfirmationInfo = ({
  bottleType,
  bottleName,
  bottleAmount,
  bottleDate,
  targetOfBottle,
  className,
}: ConfirmationInfoProps) => {
  const { t } = useTranslation()
  const typeOfBottle = useGetTypeOfBottleFromUrl()

  if (typeOfBottle === 'charitable') {
    bottleAmount = '0'
  }

  return (
    <div className={`${styles.info} ${className}`}>
      {bottleType && (
        <>
          <div>
            <p className={styles.subtitle}>{t('confirmation_info.bank_type')}</p>
            <p className={styles.title}>{bottleType}</p>
          </div>
          <div className={styles.line} />
        </>
      )}

      {typeOfBottle === 'charitable' && (
        <>
          <div>
            <p className={styles.subtitle}>{t('confirmation_info.target_of_bank')}</p>
            <p className={styles.title}>{targetOfBottle}</p>
          </div>
          <div className={styles.line} />
        </>
      )}

      <div>
        <p className={styles.subtitle}>{t('confirmation_info.bank_name')}</p>
        <p className={styles.title}>{bottleName}</p>
      </div>
      <div className={styles.line} />
      <div>
        <p className={styles.subtitle}>{t('confirmation_info.amount_received_bank')}</p>
        <p className={styles.title}>
          {bottleAmount === '' || bottleAmount === '0'
            ? t('confirmation_info.any')
            : t('confirmation_info.stars', { number: bottleAmount })}
        </p>
      </div>
      <div className={styles.line} />
      <div>
        <p className={styles.subtitle}>{t('confirmation_info.bank_will_available')}</p>
        <div className={styles.date}>
          <p className={styles.title}>{t('confirmation_info.from', { date: changeFormatOfDate(bottleDate.from) })}</p>
          <p className={styles.title}>{t('confirmation_info.to', { date: changeFormatOfDate(bottleDate.to) })}</p>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationInfo
